import { render, staticRenderFns } from "./activity-sign521.vue?vue&type=template&id=9d4aa64e&scoped=true&"
import script from "./activity-sign521.vue?vue&type=script&lang=js&"
export * from "./activity-sign521.vue?vue&type=script&lang=js&"
import style0 from "./activity-sign521.vue?vue&type=style&index=0&id=9d4aa64e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4aa64e",
  null
  
)

export default component.exports